import { render, staticRenderFns } from "./Johansen.vue?vue&type=template&id=15f26c70&scoped=true&"
import script from "./Johansen.vue?vue&type=script&lang=js&"
export * from "./Johansen.vue?vue&type=script&lang=js&"
import style0 from "./Johansen.vue?vue&type=style&index=0&id=15f26c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f26c70",
  null
  
)

export default component.exports